import React from "react";
import { cn } from "@/lib/utils";

interface DashboardGreetingProps {
  name: string;
  message: string;
  className?: string;
}

export const DashboardGreeting: React.FC<DashboardGreetingProps> = ({
  name,
  message,
  className,
}) => {
  return (
    <div
      className={cn(
        "flex gap-2 text-eathy-comfort-1 font-geist text-base font-normal tracking-normal",
        className,
      )}
    >
      <span>Hey, {name}!</span>
      <span className="opacity-50">{message}</span>
    </div>
  );
};
